import React, { useEffect, useState } from "react";

interface UpdateInfo {
  version: string;
  url: string;
}

const UpdateBanner: React.FC = () => {
  const [update, setUpdate] = useState<UpdateInfo | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!window.electronAPI) return;
    window.electronAPI.onUpdateAvailable((info) => {
      setUpdate(info);
      setDismissed(false);
    });
  }, []);

  if (!update || dismissed) return null;

  return (
    <div style={{
      background: "rgba(37, 99, 235, 0.18)",
      borderBottom: "1px solid rgba(59, 130, 246, 0.35)",
      padding: "8px 24px",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      fontSize: "13px",
      color: "#bfdbfe",
      flexWrap: "wrap",
    }}>
      <span style={{ flex: 1 }}>
        <strong style={{ color: "#93c5fd" }}>HyperPDF {update.version}</strong> is
        available — download the latest installer from GitHub.
      </span>
      <a
        href={update.url}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          background: "#2563eb",
          color: "#fff",
          padding: "5px 14px",
          borderRadius: "6px",
          fontWeight: 600,
          textDecoration: "none",
          fontSize: "12px",
          whiteSpace: "nowrap",
        }}
      >
        Download
      </a>
      <button
        onClick={() => setDismissed(true)}
        style={{
          background: "none",
          border: "none",
          color: "#64748b",
          cursor: "pointer",
          fontSize: "16px",
          lineHeight: 1,
          padding: "2px 4px",
        }}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};

export default UpdateBanner;
